import React from 'react';
import PropTypes from 'prop-types';
import Restrict from '@client/helperComponents/restrict/Restrict';

function RestrictedSuperAdmin({ children }) {
  function showOfferAdminFeatures(restrictions) {
    return restrictions.isAuthorized;
  }

  return (
    <Restrict permissions={['SUPER_ADMIN']}>
      {(restrictions) => showOfferAdminFeatures(restrictions) && children}
    </Restrict>
  );
}

RestrictedSuperAdmin.propTypes = {
  children: PropTypes.object,
};

export default RestrictedSuperAdmin;
